import {
  CalendarClock,
  PhoneCall,
  StickyNote,
  Utensils,
  Headphones,
  Play,
  Send,
  FilePen,
  Video,
  Palmtree,
  Monitor,
  Presentation,
  Home,
  Plane,
  Gift,
  TrendingUp,
  Wrench,
  Tag,
  Mail,
} from "lucide-react";
import type { KeyValuePairIconProps } from "@repo/types/ui/keyValuePairs";

export const InbuiltIconKeyValuePairs: readonly KeyValuePairIconProps[] = [
  { id: "calendarClock", icon: CalendarClock },
  { id: "phoneCall", icon: PhoneCall },
  { id: "stickyNote", icon: StickyNote },
  { id: "email", icon: Mail },
] as const;

export const CustomIconKeyValuePairs: readonly KeyValuePairIconProps[] = [
  { id: "food", icon: Utensils },
  { id: "support", icon: Headphones },
  { id: "play", icon: Play },
  { id: "send", icon: Send },
  { id: "notes", icon: FilePen },

  { id: "video", icon: Video },
  { id: "travel", icon: Palmtree },
  { id: "computer", icon: Monitor },
  { id: "presentation", icon: Presentation },
  { id: "home", icon: Home },

  { id: "flight", icon: Plane },
  { id: "gift", icon: Gift },
  { id: "growth", icon: TrendingUp },
  { id: "tools", icon: Wrench },
  { id: "tag", icon: Tag },
] as const;
